<div class="w-full text-center">
    <div class="flex justify-between gap-2 w-ful mt-3" *ngFor="let item of priceDetails?.dayPriceDetails">
        <span class="text-sm text-black-300">{{item.count}} شب {{item.unitPrice | toToman | number: '2.'}} تومانی</span>
        <span class="text-sm text-black-300">{{item.finalPrice | toToman | number: '2.'}} <b
                class="text-xs text-black-200">تومان</b></span>
    </div>
    <div class="flex justify-between gap-2 w-full my-4" *ngFor="let item of priceDetails?.otherDetails">
        <span class="text-sm text-black-300">{{item.title}}</span>
        <span class="text-sm text-black-300">{{item.finalPrice | toToman | number: '2.'}} <b
                class="text-xs text-black-200">تومان</b></span>
    </div>
    <div class="flex justify-between gap-2 w-full bg-metal-50 rounded-lg p-2 mt-4">
        <span class="text-base font-bold text-black-500">مبلغ کل رزرو</span>
        <span class="text-xl font-bold text-black-500">{{priceDetails?.finalPrice || 0 | toToman | number: '2.'}} <b
                class="text-xs text-black-200">تومان</b></span>
    </div>
  
    <div class="w-full mt-5">
        <button id="make-reservation-btn"
          [disabled]="loading || updatingPrices() || pdpUiService.hotelInfo().Type == 2"
            color="primary" class="!h-11 bg-blue-500 hidden rounded-lg text-white w-full lg:block" 
            [ngClass]="{'opacity-50 cursor-not-allowed': loading || updatingPrices() || pdpUiService.hotelInfo().Type == 2}"
            (click)="goToFollowReservation()">
            {{loading ?
             'در حال انجام اقدام به رزرو...' :
              updatingPrices() ? 'در حال دریافت قیمت...' :
               'اقدام به رزرو'}}
        </button>
    </div>
</div>